<template>
<div class="criterion" :class="[criterionCols[criterion.name] ? criterionCols[criterion.name]: 'calc-col-12']">

        <h4 class="calc-heading">{{criterion.title}}</h4>

            <div :is="inputComponent"
                 :name="criterion.name"
                 :variants="criterion.values"
                 :selectedValue="selectedCriterionValue"
                 :postfix ="criterion.postfix"
                 :placeholder ="criterion.placeholder"
                 :unvalid ="criterion.unvalid"
            >
                <button  v-if="criterion.toggleChilds" @click="showChild" class="show-child-input">+</button>
            </div>


    <div v-for="(child, i) in groupInputs" :key="child.id">


        <div :is="inputComponent"
             :name="child.name"
             :variants="child.values"
             :selectedValue="selectedCriterionValue"
             :postfix ="child.postfix"
             :placeholder ="child.placeholder"
             v-show="isVisibleChild(i)"
        >
        </div>

    </div>


    <div v-if="criterion.image" class="criterion-image"><img :src="criterion.image" /> </div>



</div>

</template>

<script>
    import CriterionInputRadio from './CriterionInputRadio';
    import CriterionInputNumber from './CriterionInputNumber';

    export default {
        data(){
            return{
                radioComponent : 'criterion-input-radio',
                numberComponent : 'criterion-input-number',

                criterionCols : {
                    //roof
                    roofing_lenght : 'calc-col-6 calc-col-6-sm calc-col-12-xs',
                    heating_width : 'calc-col-6 calc-col-6-sm calc-col-12-xs',

                    //drain
                    chute_total_length : 'calc-col-6 calc-col-6-sm calc-col-12-xs',
                    drain_height: 'calc-col-6 calc-col-12-xs',

                },

                childsCounter : 0
            }
        },
        props:['criterion'],
        components:{
            CriterionInputRadio,
            CriterionInputNumber
        },
        computed: {
            inputComponent(){
                return this[this.criterion.inputType+'Component'] || this.numberComponent;
            },
            selectedCriterionValue(){
                return this.$store.getters.getSelectedCriteria[this.criterion.name]
            },
            groupInputs(){
                return this.$store.getters.getCriterionGroup(this.criterion.name)
            },
        },
        methods : {
            showChild(){
              this.childsCounter++;
            },
            isVisibleChild(i){
                return !this.criterion.toggleChilds || this.childsCounter > i
            }
        }
    }
</script>

<style scoped>
    .criterion-image{
        margin-bottom: 30px;
    }

    .show-child-input{
        font-size:27px;
        border-radius: 50%;
        background: #eb1616;
        border:0;
        box-shadow: none;
        color:#fff;
        width: 40px;
        height: 40px;
        padding: 0;
        text-align: center;
        line-height: 40px;
        margin-left: 15px;
    }
</style>